/* 三國逗陣打 · 私訊面板（v0.4.0；設計見 docs/DM-DESIGN.md）
 * 右下角：收合時是「💬 私訊」膠囊＋未讀數；展開有「對話」「玩家」兩個分頁，點一列進單一對話。
 * 面板掛在主選單 #select 裡：遊戲中主選單隱藏，面板跟著消失（訊息照收、只累加未讀），玩家卡片（modal）也自然蓋在面板上面。
 * 名字一律用 plink（data-pid）：點了就由 home.ts 的全站委派打開玩家卡片。資料走 src/net/social.ts 的社交連線。 */
// @ts-nocheck — 和 home.ts 一樣，型別之後再補
import { SG } from '../core/sg.ts';

const MAX = 120;
const ST = { menu: '線上', lobby: '房間中', queue: '排隊中', game: '遊戲中', offline: '離線' };
const esc = (t) => String(t == null ? '' : t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
const plink = (name, pid) => `<button type="button" class="plink" data-pid="${esc(pid)}">${esc(name)}</button>`;
const hm = (t) => { const d = new Date(t); return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0'); };
const ago = (t) => { if (!t) return '離線'; const s = (Date.now() - t) / 1000; return '離線 · ' + (s < 3600 ? Math.max(1, Math.round(s / 60)) + ' 分鐘前' : s < 86400 ? Math.round(s / 3600) + ' 小時前' : Math.round(s / 86400) + ' 天前'); };

const ui = {
  root: null, open: false, tab: 'chats', peer: null, // peer：開著的對話 { id, nick }
  threads: new Map(), // pid → { lines: [{ from, text, ts, c?, failed? }], status }
  players: null, page: 0, q: '', qTimer: 0,
  menu: false, settings: false, coolUntil: 0, seq: 0, note: '',
};
const S = () => SG.Social;
const st = () => S() && S().state;
const me = () => (st() ? st().me.id : null);
const send = (m) => S() && S().send(m);
const thread = (pid) => { let t = ui.threads.get(pid); if (!t) ui.threads.set(pid, (t = { lines: [], status: null, loaded: false })); return t; };
const shown = () => ui.root && ui.open && !document.getElementById('select').hidden && !document.hidden;

// ---------- 對外：卡片、好友清單的「私訊」按鈕呼叫 ----------
function openDm(pid, nick) {
  if (!st() || pid === me()) return;
  ui.open = true; ui.peer = { id: pid, nick: nick || pid }; ui.menu = false; ui.note = '';
  const t = thread(pid);
  if (!t.loaded) send({ t: 's:dmhist', with: pid }); else send({ t: 's:dmread', with: pid });
  render(true);
}
SG.DM = { open: openDm };

// ---------- 伺服器推來的私訊、歷史、玩家列表、錯誤 ----------
function onDm(m) {
  if (m.t === 's:dm') {
    const mine = m.from === me(), pid = mine ? m.to : m.from, t = thread(pid);
    const i = mine && m.c != null ? t.lines.findIndex((l) => l.c === m.c) : -1;
    const line = { from: m.from, text: m.text, ts: m.ts };
    if (i >= 0) t.lines[i] = line; else t.lines.push(line);
    if (t.lines.length > 100) t.lines.splice(0, t.lines.length - 100);
    if (!mine && ui.peer && ui.peer.id === pid && shown()) send({ t: 's:dmread', with: pid });
    if (!mine && !shown()) pulse();
    if (ui.peer && ui.peer.id === pid) renderBody(true);
    return;
  }
  if (m.t === 's:dmhist') {
    const t = thread(m.with), pend = t.lines.filter((l) => l.c != null);
    t.lines = m.lines.concat(pend); t.loaded = true; t.status = m.status;
    if (ui.peer && ui.peer.id === m.with) { ui.peer.nick = m.nick; render(true); }
    return;
  }
  if (m.t === 's:players') { ui.players = m; ui.page = m.page; if (ui.open && !ui.peer && ui.tab === 'players') renderBody(); return; }
  if (m.t === 'err') { // 帶流水號：送不出去的那一則標成失敗，原因顯示在輸入框上方
    for (const t of ui.threads.values()) { const l = t.lines.find((x) => x.c === m.c); if (l) { l.failed = true; l.c = null; } }
    ui.note = m.text;
    if (m.wait) { ui.coolUntil = Date.now() + Math.min(m.wait, 600e3); tickCool(); }
    if (ui.peer) { renderBody(); renderFoot(); }
  }
}

// ---------- 畫面 ----------
function mount() {
  const home = document.getElementById('select'); if (!home || ui.root) return;
  ui.root = document.createElement('aside'); ui.root.className = 'dm'; ui.root.setAttribute('aria-label', '私訊');
  ui.root.innerHTML = '<button type="button" class="dm-pill" data-a="toggle" aria-expanded="false"><span aria-hidden="true">💬</span> 私訊<b class="dm-n" hidden></b></button><section class="dm-panel" hidden><header class="dm-head"></header><div class="dm-body"></div><footer class="dm-foot" hidden></footer></section>';
  home.appendChild(ui.root);
  ui.root.addEventListener('click', onClick);
  ui.root.addEventListener('input', onInput);
  ui.root.addEventListener('keydown', (e) => { if (e.key === 'Enter' && e.target.id === 'dm-text' && !e.isComposing) { e.preventDefault(); submit(); } if (e.key === 'Escape') { ui.open = false; render(); } });
}
const $q = (sel) => ui.root.querySelector(sel);
function unreadTotal() { const s = st(); return s && s.dms ? s.dms.reduce((n, d) => n + d.unread, 0) : 0; }
function pulse() { const p = ui.root && $q('.dm-pill'); if (!p) return; p.classList.remove('pulse'); void p.offsetWidth; p.classList.add('pulse'); }

function render(scroll) {
  const s = st();
  if (!s || !s.dms) { if (ui.root) ui.root.hidden = true; return; } // 沒登入（或伺服器還沒有私訊功能）：不顯示
  mount(); ui.root.hidden = false;
  const n = unreadTotal(), badge = $q('.dm-n');
  badge.hidden = !n; badge.textContent = n > 99 ? '99+' : String(n);
  const pill = $q('.dm-pill'); pill.hidden = ui.open; pill.setAttribute('aria-expanded', String(ui.open));
  $q('.dm-panel').hidden = !ui.open;
  ui.root.classList.toggle('open', ui.open);
  if (!ui.open) return;
  renderHead(); renderBody(scroll); renderFoot();
}
function renderHead() {
  const h = $q('.dm-head'), s = st();
  if (ui.peer) {
    const p = ui.peer, status = peerStatus(p.id), blocked = s.blocked.some((b) => b.id === p.id), friend = s.friends.some((f) => f.id === p.id);
    h.innerHTML = `<button type="button" class="dm-ic" data-a="back" aria-label="回到對話列表">←</button>
      <div class="dm-who"><i class="dot s-${status}"></i>${plink(p.nick, p.id)}<small>${ST[status] || ''}</small></div>
      <button type="button" class="dm-ic" data-a="menu" aria-label="更多" aria-expanded="${ui.menu}">⋯</button>
      <button type="button" class="dm-ic" data-a="toggle" aria-label="收合">─</button>
      ${ui.menu ? `<div class="dm-menu" role="menu">
        <button type="button" role="menuitem" data-pid="${esc(p.id)}">查看玩家卡片</button>
        ${!friend && !s.outgoing.some((f) => f.id === p.id) ? `<button type="button" role="menuitem" data-a="add">加好友</button>` : ''}
        ${friend && status !== 'offline' ? `<button type="button" role="menuitem" data-a="invite">邀請組隊</button>` : ''}
        <button type="button" role="menuitem" data-a="${blocked ? 'unblock' : 'block'}" class="${blocked ? '' : 'warn'}">${blocked ? '解除封鎖' : '封鎖此人'}</button></div>` : ''}`;
  } else {
    h.innerHTML = `<div class="dm-tabs" role="tablist">
        <button type="button" role="tab" data-a="tab" data-tab="chats" aria-selected="${ui.tab === 'chats'}">對話${unreadTotal() ? `<b class="dm-n">${unreadTotal()}</b>` : ''}</button>
        <button type="button" role="tab" data-a="tab" data-tab="players" aria-selected="${ui.tab === 'players'}">玩家</button></div>
      <button type="button" class="dm-ic" data-a="settings" aria-label="私訊設定" aria-expanded="${ui.settings}">⚙</button>
      <button type="button" class="dm-ic" data-a="toggle" aria-label="收合">─</button>`;
  }
}
function peerStatus(pid) {
  const s = st(), d = s.dms.find((x) => x.with === pid) || s.friends.find((x) => x.id === pid);
  if (d) return d.status;
  const p = ui.players && ui.players.list.find((x) => x.id === pid);
  return p ? p.status : thread(pid).status || 'offline';
}
// 搜尋框重畫時保住游標：玩家列表回來時整塊重畫，再把焦點放回搜尋框
function renderBody(scroll) {
  const q = ui.root && $q('#dm-q'), focused = q && document.activeElement === q, pos = q ? q.selectionStart : 0;
  drawBody(scroll);
  if (focused) { const n = $q('#dm-q'); if (n) { n.focus(); try { n.setSelectionRange(pos, pos); } catch (x) { /* type=search 某些瀏覽器不支援 */ } } }
}
function drawBody(scroll) {
  const b = $q('.dm-body'), s = st(); if (!b || !ui.open) return;
  if (ui.peer) {
    const t = thread(ui.peer.id), status = peerStatus(ui.peer.id), blocked = s.blocked.some((x) => x.id === ui.peer.id);
    const atEnd = b.scrollHeight - b.scrollTop - b.clientHeight < 40;
    const notice = blocked ? '你封鎖了這位玩家，看不到對方的新訊息。' : status === 'game' ? '對方遊戲中，結束後才會看到。' : status === 'offline' ? '對方離線，訊息會留著等他上線。' : '';
    b.className = 'dm-body dm-thread';
    b.innerHTML = (notice ? `<p class="dm-notice">${notice}</p>` : '') + (t.loaded || t.lines.length
      ? t.lines.map((l) => { const mine = l.from === me(); return `<div class="dm-msg${mine ? ' me' : ''}${l.c != null ? ' pending' : ''}${l.failed ? ' failed' : ''}"><p>${esc(l.text)}</p><small>${l.failed ? '沒有送出' : l.c != null ? '傳送中…' : hm(l.ts)}</small></div>`; }).join('') || '<p class="dm-empty">還沒有訊息，打聲招呼吧。</p>'
      : '<p class="dm-empty">讀取中…</p>');
    if (scroll || atEnd) b.scrollTop = b.scrollHeight;
    return;
  }
  if (ui.tab === 'players') { b.className = 'dm-body'; b.innerHTML = playersHTML(); return; }
  b.className = 'dm-body';
  b.innerHTML = (ui.settings ? settingsHTML() : '') + (s.dms.length
    ? `<ul class="dm-list">${s.dms.map((d) => `<li data-a="chat" data-id="${esc(d.with)}" data-nick="${esc(d.nick)}" class="${d.unread ? 'unread' : ''}"><i class="dot s-${d.status}"></i><span class="dm-row"><span class="dm-top">${plink(d.nick, d.with)}<small>${hm(d.last.ts)}</small></span><span class="dm-prev">${d.last.mine ? '你：' : ''}${esc(d.last.text)}</span></span>${d.unread ? `<b class="dm-n">${d.unread > 99 ? '99+' : d.unread}</b>` : ''}</li>`).join('')}</ul>`
    : '<p class="dm-empty">還沒有私訊。到「玩家」分頁找人，或在玩家卡片上按「私訊」。</p>');
}
function settingsHTML() {
  const s = st();
  return `<div class="dm-set"><label><input type="checkbox" data-a="pref"${s.dmpref.friendsOnly ? ' checked' : ''}> 只接受好友私訊</label>
    <p class="on-note">封鎖名單（${s.blocked.length}）</p>${s.blocked.length ? `<ul class="dm-blocked">${s.blocked.map((x) => `<li>${plink(x.nick, x.id)}<button type="button" class="sbtn" data-a="unblock" data-id="${esc(x.id)}">解除</button></li>`).join('')}</ul>` : '<p class="on-note">沒有封鎖任何人。</p>'}</div>`;
}
function playersHTML() {
  const P = ui.players;
  const head = `<div class="dm-search"><input id="dm-q" type="search" maxlength="12" placeholder="搜尋 5 碼 ID 或暱稱" value="${esc(ui.q)}" autocomplete="off"></div>`;
  if (!P) return head + '<p class="dm-empty">讀取中…</p>';
  const rows = P.list.map((p) => `<li><i class="dot s-${p.status}"></i><span class="dm-row"><span class="dm-top">${plink(p.nick, p.id)}${p.friend ? '<em class="dm-tag">好友</em>' : ''}${p.rating ? `<small>積分 ${p.rating}</small>` : ''}</span><span class="dm-prev">${p.status === 'offline' ? ago(p.seen) : ST[p.status]}</span></span><button type="button" class="sbtn" data-a="chat" data-id="${esc(p.id)}" data-nick="${esc(p.nick)}" aria-label="私訊 ${esc(p.nick)}">💬</button></li>`).join('');
  return head + `<p class="dm-count on-note">共 ${P.total.toLocaleString()} 人 · 線上 ${P.online}</p>` + (rows ? `<ul class="dm-list">${rows}</ul>` : '<p class="dm-empty">找不到符合的玩家。</p>')
    + (P.pages > 1 ? `<nav class="dm-pager" aria-label="分頁"><button type="button" class="sbtn" data-a="page" data-p="${P.page - 1}"${P.page ? '' : ' disabled'}>上一頁</button><span>${P.page + 1} / ${P.pages}</span><button type="button" class="sbtn" data-a="page" data-p="${P.page + 1}"${P.page + 1 < P.pages ? '' : ' disabled'}>下一頁</button></nav>` : '');
}
function renderFoot() {
  const f = $q('.dm-foot'); if (!f) return;
  f.hidden = !ui.peer;
  if (!ui.peer) return;
  if (!$q('#dm-text')) f.innerHTML = `<p class="dm-err" role="status"></p><div class="dm-in"><input id="dm-text" type="text" maxlength="${MAX}" placeholder="輸入訊息…" autocomplete="off" enterkeyhint="send"><span class="dm-cnt"></span><button type="button" class="btn primary" data-a="send">送出</button></div>`;
  $q('.dm-err').textContent = ui.note;
  updateInput();
}
function updateInput() {
  const i = $q('#dm-text'); if (!i) return;
  const n = [...i.value].length, cool = ui.coolUntil > Date.now();
  $q('.dm-cnt').textContent = n ? `${n}/${MAX}` : '';
  $q('.dm-cnt').classList.toggle('over', n > MAX);
  i.disabled = cool;
  if (cool) i.placeholder = `${Math.ceil((ui.coolUntil - Date.now()) / 1000)} 秒後可再傳`; else i.placeholder = '輸入訊息…';
  $q('[data-a="send"]').disabled = cool || !i.value.trim() || n > MAX;
}
let coolTimer = 0;
function tickCool() { clearInterval(coolTimer); coolTimer = setInterval(() => { updateInput(); if (ui.coolUntil <= Date.now()) { clearInterval(coolTimer); ui.note = ''; if ($q('.dm-err')) $q('.dm-err').textContent = ''; } }, 500); }

function submit() {
  const i = $q('#dm-text'); if (!i || !ui.peer || ui.coolUntil > Date.now()) return;
  const text = i.value.trim(); if (!text || [...text].length > MAX) return;
  const c = 'c' + ++ui.seq;
  thread(ui.peer.id).lines.push({ from: me(), text, ts: Date.now(), c });
  send({ t: 's:dm', id: ui.peer.id, text, c });
  i.value = ''; ui.note = ''; renderBody(true); renderFoot(); i.focus();
}
function showTab(tab) {
  ui.tab = tab;
  if (tab === 'players') send({ t: 's:players', page: ui.page, q: ui.q }); else send({ t: 's:playersoff' });
  render();
}
function onClick(e) {
  if (e.target.closest('[data-pid]')) { ui.menu = false; return; } // 名字：交給 home.ts 開玩家卡片
  const el = e.target.closest('[data-a]'); if (!el) return;
  const a = el.dataset.a;
  if (a === 'toggle') {
    ui.open = !ui.open; ui.menu = false;
    if (ui.open && ui.peer) send({ t: 's:dmread', with: ui.peer.id });
    if (ui.open && !ui.peer && ui.tab === 'players') send({ t: 's:players', page: ui.page, q: ui.q });
    if (!ui.open) send({ t: 's:playersoff' });
    render(true); if (ui.open && ui.peer && $q('#dm-text')) $q('#dm-text').focus();
  } else if (a === 'tab') showTab(el.dataset.tab);
  else if (a === 'chat') openDm(el.dataset.id, el.dataset.nick);
  else if (a === 'back') { ui.peer = null; ui.menu = false; ui.note = ''; $q('.dm-foot').innerHTML = ''; if (ui.tab === 'players') send({ t: 's:players', page: ui.page, q: ui.q }); render(); }
  else if (a === 'menu') { ui.menu = !ui.menu; renderHead(); }
  else if (a === 'settings') { ui.settings = !ui.settings; if (ui.tab !== 'chats') showTab('chats'); else render(); }
  else if (a === 'send') submit();
  else if (a === 'page') { ui.page = Math.max(0, +el.dataset.p | 0); send({ t: 's:players', page: ui.page, q: ui.q }); }
  else if (a === 'add') { send({ t: 's:add', code: ui.peer.id }); ui.menu = false; renderHead(); }
  else if (a === 'invite') { send({ t: 's:invite', id: ui.peer.id }); ui.menu = false; renderHead(); }
  else if (a === 'block') { if (confirm(`確定要封鎖 ${ui.peer.nick} 嗎？對方的私訊你將不會收到。`)) send({ t: 's:block', id: ui.peer.id }); ui.menu = false; renderHead(); }
  else if (a === 'unblock') { send({ t: 's:unblock', id: el.dataset.id || ui.peer.id }); ui.menu = false; }
  else if (a === 'pref') send({ t: 's:dmpref', friendsOnly: el.checked });
}
function onInput(e) {
  if (e.target.id === 'dm-text') updateInput();
  else if (e.target.id === 'dm-q') { // 搜尋：停 300ms 才送
    ui.q = e.target.value; ui.page = 0; clearTimeout(ui.qTimer);
    ui.qTimer = setTimeout(() => send({ t: 's:players', page: 0, q: ui.q }), 300);
  }
}
function init() {
  if (!S()) { setTimeout(init, 0); return; }
  S().on((state) => {
    if (!state) { ui.threads.clear(); ui.peer = null; ui.players = null; }
    render();
  });
  S().onDm(onDm);
  // 回到選單（或切回分頁）時：開著的對話補標已讀
  const sel = document.getElementById('select');
  if (sel) new MutationObserver(() => { if (shown() && ui.peer) send({ t: 's:dmread', with: ui.peer.id }); }).observe(sel, { attributes: true, attributeFilter: ['hidden'] });
  document.addEventListener('visibilitychange', () => { if (shown() && ui.peer) send({ t: 's:dmread', with: ui.peer.id }); });
}
init();
